import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form, message, Table, Switch, Button, Tag } from "antd";
import userActions from "../../redux/service/actions";
import userActionsServices from "../../redux/incentive/actions";
import moment from "moment";
import SearchBar from "../../utils/Searchbar";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import ServiceModal from "./components/ServiceFormModel";

const columns = [
  {
    title: "#",
    dataIndex: "key",
    key: "key",
    width: 100, // Fixed width
  },
  {
    title: "Service Name",
    dataIndex: "serviceName",
    key: "serviceName",
    sorter: (a, b) =>
      String(a?.serviceName || "").localeCompare(String(b?.serviceName || "")),
    width: 100, // Fixed width
  },


  // {
  //   title: "Priority",
  //   dataIndex: "priority",
  //   key: "priority",
  //   sorter: (a, b) => a.priority - b.priority,
  //   width: 100, // Fixed width
  // },
  {
    title: "Created Date",
    dataIndex: "createdAt",
    // key: "createdAt",
    // sorter: (a, b) => moment(a.createdAt).unix() - moment(b.createdAt).unix(),
    // render: (date) => moment(date)?.format("MM/DD/YYYY"),
    width: 100, // Fixed width
  },
  {
    title: "Updated Date",
    dataIndex: "updatedAt",
    // key: "updatedAt",
    // sorter: (a, b) => moment(a.updatedAt).unix() - moment(b.updatedAt).unix(),
    // render: (date) => moment(date).format("MM/DD/YYYY"),
    width: 100, // Fixed width
  },
  {
    title: "ACTIONS",
    dataIndex: "action",
    width: 100, // Fixed width
  },
];

const {
  getServiceData,
  deleteService,
  ServiceResetMessage,
  openForm,
  ServiceReset,
  addService,
} = userActions;

const {
    getServices,
  } = userActionsServices;

function Service() {
  const dispatch = useDispatch();
  const [UserForm] = Form.useForm();
  const [messageApi, contextHolder] = message.useMessage();
  const {
    serviceData,
    loading,
    show,
    totalData,
    error,
    buttonLoading,
  } = useSelector((state) => state.serviceReducer);
  const sucessMessage = useSelector((state) => state.serviceReducer.message);
  const {servicelist } = useSelector(
    (state) => state.incentiveReducer || {}
  );
  // console.log(servicelist)
  const profileData = useSelector(state => state.authReducer.profileData);

  const [fromTitle, setfromTitle] = useState("");
  const [formButton, setformButton] = useState("");
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [editFlag, setEditFlag] = useState(false);
  const [selectedModules, setSelectedModules] = useState([]);

  const [tableParams, setTableParams] = useState({
    current: 1,
    pageSize: 10,
  });


  

  const dataSource =
    serviceData &&
    serviceData?.length > 0 &&
    serviceData?.map((service, index) => {
      return {
        key: (tableParams.current - 1) * tableParams?.pageSize + index + 1,
        serviceName: service|| <Tag>{""}</Tag>,
        agentId: service?.agentId || <Tag>{""}</Tag>,
        priority: service?.priority || <Tag>{""}</Tag>,
        createdAt: service?.createdAt || <Tag>{""}</Tag>,
        updatedAt: service?.updatedAt || <Tag>{""}</Tag>,
        action:service?.action || <Tag>{""}</Tag>,
        // action: (
        //   <>
        //     <Switch
        //       checkedChildren={<CheckOutlined />}
        //       unCheckedChildren={<CloseOutlined />}
        //       checked={service?.isActive}
        //       onClick={(e) => dispatch(deleteService(service?._id,!service?.isActive , profileData?.orgId))}
        //     />
        //   </>
        // ),
      };
    });
  let timeoutId;
  const handleFilterChange = (e) => {
    const agentId = profileData?.orgId
    e.preventDefault();
    const value = e.target.value;
    if (timeoutId) {
      clearTimeout(timeoutId); // Clear the previous timeout if it exists
    }
    timeoutId = setTimeout(() => {
      if(serviceData?.length >= 0 && profileData) {
      dispatch(getServiceData(0, 10,"" , "" , value , agentId));
      }
    }, 1000);
  };

  const handleTableChange = (pagination, filters, sorter) => {
    const agentId = profileData?.orgId
    const { current, pageSize } = pagination;
    setTableParams({ current, pageSize });
    dispatch(getServiceData(current, pageSize,"","","",agentId));
  };

  const success = (text) => {
    const hide = messageApi.open({
      type: "success",
      content: text,
    });
    setTimeout(hide, 4000);
    dispatch(ServiceResetMessage());
  };
  const errorHandle = (text) => {
    const hide = messageApi.open({
      type: "error",
      content: text,
    });
    setTimeout(hide, 4000);
    dispatch(ServiceResetMessage());
  };

  const handleSubmit = (values) => {
    const payload = {
        "serviceName": values?.service,
      agentId: profileData?.orgId,
    };
    dispatch(addService(payload))
    
  };
  const handleModuleChangenew = (selectedModules) => {
    setSelectedModules(selectedModules);
  };

  const showModal = () => {
    setfromTitle("ADD SERVICES");
    setformButton("Submit");
    setEditFlag(false);
    dispatch(openForm());
    UserForm.resetFields();
    setSelectedModules([]);
  };
  const handleCancel = () => {
    dispatch(ServiceReset());
    UserForm.resetFields();
    setSelectedModules([]);
  };

  useEffect(() => {
    if (sucessMessage !== null && sucessMessage !== undefined) {
      success(sucessMessage);
    }
    if (error !== null && error !== undefined) {
      errorHandle(error);
    }
  }, [sucessMessage, error]);
  
  useEffect(() => {
    if(profileData?.orgId) {
      dispatch(getServiceData(0 , 10,"","","",profileData?.orgId));
      dispatch(getServices());
    }

  }, [dispatch , profileData]);

  return (
    <>
      {contextHolder}
      <div className="mainContain">
        <h1 className="transaction">Services</h1>
        <div className="d-flex justify-content-between align-items-center">
          <SearchBar onChange={handleFilterChange} />
          {/* <Button
            style={{
              backgroundColor: "#073763",
              borderColor: "#073763",
              color: "white",
            }}
            size="large"
            onClick={showModal}
          >
            Add Service
          </Button> */}
        </div>
        <div className="mt-3">
          <Table
            columns={columns}
            dataSource={dataSource}
            loading={loading}
            scroll={{ x: 600 }}
          pagination={false}
            onChange={handleTableChange}
          />
        </div>
      </div>
      <ServiceModal
        fromTitle={fromTitle}
        open={show}
        buttonLoading={buttonLoading}
        confirmLoading={confirmLoading}
        handleCancel={handleCancel}
        handleSubmit={handleSubmit}
        formButton={formButton}
        UserForm={UserForm}
        selectedModules={selectedModules}
        editFlag={editFlag}
        servicelist={servicelist}
        handleModuleChangenew={handleModuleChangenew}
      />
    </>
  );
}

export default Service;
